import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { useHistory } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import ValidateService from "../../../components/ValidateService/ValidateService";

// PAGE
import P241List from "../241/P241List";

// SERVICE
import { pAssessmentList, pAssessmentInfo } from "../../../service/200/P241Service";

export default function P241() {
    const toast = useRef(null);
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState("");

    // DATA
    const [dataFornP241, setDataFornP241] = useState([]);
    // const [dataFornP241Info, setDataFornP241Info] = useState([]);
    const [errData, setErrData] = useState(null);

    // SEARCH
    const [searchData, setSearchData] = useState({
        contractNo: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });
    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state && history.location.state.dataSrh) {
                setSearchData({
                    ...searchData,
                    ...history.location.state.dataSrh,
                    userId: dataUserSession().userId,
                });
                setPage(history.location.state.form);
            } else {
                history.push("/240");
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        if (searchData.contractNo !== "") {
            onGetAssessmentList();
            // onGetAssessmenInfo();
        }
    }, [searchData]);

    const onGetAssessmentList = () => {
        setLoading(true);
        const req = {
            contractNo: searchData.contractNo,
            userId: searchData.userId,
        };
        pAssessmentList(req).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 0;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataFornP241(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    // const onGetAssessmenInfo = () => {
    //     setLoading(true);
    //     const req = {
    //         assessmentNo: 1,
    //         contractNo: searchData.contractNo,
    //         userId: searchData.userId,
    //     };
    //     pAssessmentInfo(req).then(
    //         (res) => {
    //             setLoading(false);
    //             if (res != undefined) {
    //                 let temp = [];
    //                 let index = 0;
    //                 res.forEach((element) => {
    //                     temp.push({
    //                         ...element,
    //                         index: index,
    //                     });
    //                     index++;
    //                 });
    //                 setDataFornP241Info(temp);
    //                 console.log(temp);
    //             } else {
    //                 showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
    //             }
    //         },
    //         function (err) {
    //             setLoading(false);
    //             setErrData(err);
    //         }
    //     );
    // };
    const handlerActionEdit = (rowData) => {
        history.push({
            pathname: "/242",
            state: { dataSrh: { assessmentNo: rowData.data.assessmentNo, contractNo: rowData.data.contractNo, updateUserId: rowData.data.updateUserId } },
        });
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };
    const handlerActionPage = (key) => {
        switch (key) {
            case "B":
                // history.push(page);
                history.push("/208");
                break;
            case "242":
                history.push({
                    pathname: `/242`,
                    state: { dataSrh: { assessmentNo: 0, contractNo: searchData.contractNo } },
                });

                break;
            default:
                break;
        }
    };

    const setViewInfo = (name) => {
        return dataFornP241.length > 0 ? dataFornP241[0][name] : "";
    };
    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" disabled={true} maxLength="20" value={setViewInfo("contractNo")} />
                            </div>
                        </div>
                        {/* <h2 className="p-m-0">แสดงรายการประเมินของสัญญา</h2>
                        <hr /> */}
                        <P241List dataTable={dataFornP241} setEditDialog={handlerActionEdit} goPage={handlerActionPage} />
                    </div>
                </div>
            </div>
        </>
    );
}
